import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { INotification } from '@services/notification.service';
import { NotificationStateService } from '@services/notification-state.service';

@Component({
  selector: 'app-notification-dropdown',
  standalone: false,
  templateUrl: './notification-dropdown.component.html',
  styleUrls: ['./notification-dropdown.component.scss']
})
export class NotificationDropdownComponent implements OnInit, OnDestroy {
  unreadCount: number = 0;
  recentNotifications: INotification[] = [];
  private destroy$ = new Subject<void>();

  constructor(
    private notificationStateService: NotificationStateService,
    private router: Router
  ) {}

  ngOnInit(): void {
    // Subscribe to unread count
    this.notificationStateService
      .getUnreadCount()
      .pipe(takeUntil(this.destroy$))
      .subscribe((count) => {
        this.unreadCount = count;
      });

    // Subscribe to recent notifications
    this.notificationStateService
      .getRecentNotifications()
      .pipe(takeUntil(this.destroy$))
      .subscribe((notifications) => {
        this.recentNotifications = notifications;
      });
  }


  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  /**
   * Handle notification click
   */
  onNotificationClick(notification: INotification, overlayPanel: any): void {
    // Close dropdown
    overlayPanel.hide();

    // Mark as read if not already read (skip API for tour notifications)
    if (!notification.isRead && !notification._id.startsWith('tour-')) {
      this.notificationStateService.markAsRead(notification._id);
    }

    // Navigate to order
    if (notification.data?.purchaseOrderId) {
      this.router.navigate(['/orders', notification.data.purchaseOrderId]);
    }
  }

  /**
   * Mark all as read
   */
  markAllAsRead(overlayPanel: any): void {
    this.notificationStateService.markAllAsRead();
    overlayPanel.hide();
  }

  /**
   * Navigate to full notification list
   */
  viewAll(overlayPanel: any): void {
    overlayPanel.hide();
    this.router.navigate(['/notifications']);
  }

  /**
   * Check if there are any notifications
   */
  get hasNotifications(): boolean {
    return this.recentNotifications.length > 0;
  }

  /**
   * Check if mark all as read button should be disabled
   */
  get markAllDisabled(): boolean {
    return this.unreadCount === 0;
  }
}
